import { createAction } from 'redux-actions';

export const resetGuestSummaryReport = createAction(
  'RESET_INVENTORY_GUEST_SUMMARY_REPORT'
);

export const updateGuestSummaryReportSearchQuery = createAction(
  'UPDATE_INVENTORY_GUEST_SUMMARY_REPORT_SEARCH_QUERY'
);
